export function zoomAction(list, ctx) {
  const {
    designer
  } = ctx;
  const action = designer.zoomFitState.compAction;
  list.push({
    ...action,
    title: '画布缩放',
    place: ['contextMenu']
  });
  return list;
}